var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66602 8.66697C6.95232 9.04972 7.31759 9.36642 7.73705 9.5956C8.15651 9.82477 8.62035 9.96105 9.09712 9.99519C9.57388 10.0293 10.0524 9.96055 10.5002 9.79349C10.9481 9.62643 11.3548 9.36502 11.6927 9.02697L13.6927 7.02697C14.2999 6.3983 14.6359 5.55629 14.6283 4.6823C14.6207 3.80831 14.2701 2.97227 13.6521 2.35424C13.0341 1.73621 12.198 1.38565 11.324 1.37806C10.45 1.37046 9.60802 1.70644 8.97935 2.31364L7.83268 3.45364",
    stroke: "#646672",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33347 7.33283C9.04716 6.95008 8.68189 6.63338 8.26243 6.40421C7.84297 6.17503 7.37913 6.03875 6.90237 6.00461C6.4256 5.97047 5.94707 6.03925 5.49924 6.20631C5.0514 6.37337 4.64472 6.63479 4.3068 6.97283L2.3068 8.97283C1.69961 9.60151 1.36363 10.4435 1.37122 11.3175C1.37881 12.1915 1.72938 13.0275 2.3474 13.6456C2.96543 14.2636 3.80147 14.6142 4.67546 14.6217C5.54945 14.6293 6.39146 14.2934 7.02013 13.6862L8.16013 12.5462",
    stroke: "#646672",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.7376a0418540d2d23d0a44a7784276f5.svg";
export { ForwardRef as ReactComponent };